<template>
  <b-navbar
    class="navbar"
    toggleable="sm"
    type="dark"
    variant="info"
    fixed
    sticky
  >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-navbar-brand>{{ currentApp }}</b-navbar-brand>

    <b-navbar-nav class="ml-auto">
      <MigrateActions />
    </b-navbar-nav>
  </b-navbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';

import MigrateActions from '@/components/MigrateActions.vue';

export default defineComponent({
  name: 'Navbar',
  components: {
    MigrateActions,
  },
  computed: {
    ...mapGetters({
      totalTasks: 'task/totalCount',
      runningTasks: 'task/runningCount',
    }),
    ...mapState({
      tasksLoading: (state: any) => state.task.loadingList,
    }),
    hasTasks(): boolean {
      return !!this.totalTasks;
    },
    currentApp() {
      const path = this.$route?.path.split('/')[1];

      if (path == 'migrate') {
        return 'Migrate';
      } else if (path == 'fields') {
        return 'Application';
      }
      return '';
    },
  },
  methods: {
    currentRoute(path: string) {
      return this.$route?.path === path;
    },
  },
});
</script>

<style>
.navbar {
  z-index: 101;
  height: 50px;
}
</style>
